import { rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useDynamicFormContext } from '../../../DynamicFormContext';
import { Button } from '../../elements/Button';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';

const ButtonWithAction = ({
  handleChange,
  label,
  uischema,
  formData,
}: FieldProps) => {
  const { useInvokeAction } = useDynamicFormContext();
  const invokeAction = useInvokeAction?.();

  const [disabled, setDisabled] = useState(false);
  const dependentValue = get(formData, uischema.options?.dependentPath);
  const actionData = uischema.options?.actionData;
  const data = {
    [actionData.data.key]: get(formData, actionData.data.keyPath),
    endpoint: actionData.data?.endpoint || undefined,
  };

  const hiddenFieldPaths = uischema.options?.hiddenFieldPaths;

  const handleInvokeAction = async () => {
    const invokeResponse: any = (await invokeAction?.({
      actionKey: actionData.actionKey,
      data: data,
    }))!;
    const fullData = invokeResponse?.data?.value;
    hiddenFieldPaths.forEach((field: any) => {
      handleChange(
        field.path,
        field.type === 'string'
          ? fullData?.[field.value]?.toString()
          : fullData?.[field.value],
      );
    });
    setDisabled(true);
  };

  useEffect(() => {
    setDisabled(false);
  }, [dependentValue]);

  return (
    <Button
      type={uischema.options?.style || 'primary'}
      onClick={handleInvokeAction}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export const ButtonWithActionEntry = {
  tester: rankWith(12, uiTypeIs('ButtonWithAction')),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(ButtonWithAction)),
};
